import { ComponentPropsWithoutRef, forwardRef } from 'react';
import FormField from './FormField';
import { controlClasses } from './controlClasses';

type Props = ComponentPropsWithoutRef<'textarea'> & {
  label?: string;
  error?: string;
};

const FormTextArea = forwardRef<HTMLTextAreaElement, Props>(
  ({ label, id, error, className, ...props }, ref) => (
    <FormField id={id} label={label} error={error}>
      <textarea
        ref={ref}
        id={id}
        aria-invalid={error ? true : undefined}
        aria-describedby={error && id ? `${id}-error` : undefined}
        className={controlClasses(!!error, className)}
        {...props}
      />
    </FormField>
  )
);

FormTextArea.displayName = 'FormTextArea';

export default FormTextArea;
